import * as Colors from 'material-ui/styles/colors';

export default {
  lassoContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute'
  },
  lassoSvgContainer: {
    width: '100%',
    height: '100%'
  },
  lassoRect: {
    fill: Colors.lightGreen500,
    fillOpacity: 0.15,
    stroke: Colors.lightGreenA400,
    strokeWidth: '1px'
  },
  lassoPotentialElement: {
    fill: 'none',
    stroke: Colors.limeA700,
  },
  lassoPotentialElementProps: {
    strokeDasharray: '2, 2',
    strokeWidth: '1px',
  }
};
